import React, { useEffect } from 'react';
import './VendorList.scss';
import { connect } from 'react-redux';
import { setConsent, setObjectConsent } from '../../../../redux/actions';
import setVendorListHeight from '../../../../scripts/lib/setVendorListHeight';

import numberToAlphabet from '../../../../scripts/lib/numberToAlphabet';


const VendorList = props => {
    useEffect(() => {
        setVendorListHeight();

        window.addEventListener('resize', setVendorListHeight);
    }, []);

    function consentSwitchOnChangeHandler(vendorId) {
        let vendorConsent = {...props.configuration.vendorConsent};

        if (props.configuration.static && props.configuration.static.vendorConsent && (props.configuration.static.vendorConsent[vendorId] === true || props.configuration.static.vendorConsent[vendorId] === false)) {
            return;
        } else {
            vendorConsent[vendorId] = !vendorConsent[vendorId];
            props.setConsent(vendorConsent);
        }
    }

    function objectSwitchOnChangeHandler(vendorId) {
        let objectConsent = {...props.configuration.objectConsent};

        if (props.configuration.static && props.configuration.static.objectConsent && (props.configuration.static.objectConsent[vendorId] === true || props.configuration.static.objectConsent[vendorId] === false)) {
            return;
        } else {
            objectConsent[vendorId] = !objectConsent[vendorId];
            props.setObjectConsent(objectConsent);
        }
    }

    function renderVendors() {
        if(props.configuration.vendorList && props.currentFilter) {
            return props.configuration.vendorList.vendors.map(vendor => {
                if (vendor[props.currentFilter.filterName].find(filterId => filterId === props.currentFilter.value.id)) {
                    return (
                        <tr key={vendor.name}>
                            <td>
                                <p>{vendor.name}</p>
                            </td>
                            <td className="center">
                                <a href={vendor.policyUrl} target="_blank" rel="noopener noreferrer"><span className="icon-external-link"></span></a>
                            </td>
                            <td>
                                <p>{vendor.purposes.join(', ')}</p>
                            </td>
                            <td>
                                <p>{numberToAlphabet(vendor.specialPurposes).join(', ')}</p>
                            </td>
                            <td>
                                <p>{vendor.features.join(', ')}</p>
                            </td>
                            <td>
                                <p>{numberToAlphabet(vendor.specialFeatures).join(', ')}</p>
                            </td>
                            <td className="center">
                                <label className="switch">
                                    <input type="checkbox" vendor-id={vendor.id} onChange={() => consentSwitchOnChangeHandler(vendor.id)} checked={(props.configuration.vendorConsent && props.configuration.vendorConsent[vendor.id] ) ? true : false}  />
                                    <i className="slider" />
                                </label>
                            </td>
                            <td>
                                <p>{vendor.legIntPurposes.join(', ')}</p>
                            </td>
                            <td>
                                <p>{vendor.legIntPurposes.length > 0? 
                                    <label className="switch">
                                        <input type="checkbox" legint-id={vendor.id} onChange={() => objectSwitchOnChangeHandler(vendor.id)} checked={(props.configuration.objectConsent && props.configuration.objectConsent[vendor.id] ) ? true : false}  />
                                        <i className="slider orange" />
                                    </label>
                                 : null}</p>
                            </td>
                        </tr>
                    )
                    
                } else {
                    return null;
                }
            });

            
        } else {
            return null;
        }
    };

    const getLabel = (label) => {
        return label.split(new RegExp(/(?:\r\n|\r|\n)/g)).map((object, index) => {
            if (index > 0) {
            return (<i key={index}><br/>{object}</i>);
            } else {
                return (<i key={index}>{object}</i>);
            }
        });
    }

    return (
        <div id="vendorlist">
            <table>
                <thead>
                    <tr>
                        <th>
                            <h2>{getLabel(props.currentLanguage.text.labels.vendorName)}</h2>
                        </th>
                        <th>
                            <h2>{getLabel(props.currentLanguage.text.labels.PrivacyUrl)}</h2>
                        </th>
                        <th>
                            <h2>{getLabel(props.currentLanguage.text.labels.purposes)}</h2>
                        </th>
                        <th>
                            <h2>{getLabel(props.currentLanguage.text.labels.specialPurposes)}</h2>
                        </th>
                        <th>
                            <h2>{getLabel(props.currentLanguage.text.labels.Features)}</h2>
                        </th>
                        <th>
                            <h2>{getLabel(props.currentLanguage.text.labels.specialFeatures)}</h2>
                        </th>
                        <th>
                            <h2>{getLabel(props.currentLanguage.text.labels.consent)}</h2>
                        </th>
                        <th>
                            <h2>{getLabel(props.currentLanguage.text.labels.legitimateInterest)}</h2>
                        </th>
                        <th>
                            <h2>{getLabel(props.currentLanguage.text.labels.objectToLegitimateInterest)}</h2>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {renderVendors()}
                </tbody>
            </table>
        </div>
    )
};

const mapStateToProps = state => {
    return {...state};
}

export default connect(mapStateToProps, {setConsent,setObjectConsent})(VendorList);